import React from 'react';
import styled from 'styled-components';
import { SupervisorForm } from './SupervisorForm';
import { NOMINATION_TEXT } from '../../lang';
import { PAGE_TEXT } from '../../../../Nomination/components/lang';
import { supTeamRoleTypeMigrateMappings } from '../../../../Nomination/components';
import { type SupervisorValue } from '../../../../Nomination/graphql';

const ROLE_TYPE = PAGE_TEXT.SUPERVISOR_TEAM.ROLE_TYPE;

export type SupervisorFormsProps = {
  data: SupervisorValue[];
};

export const SupervisorForms: React.FC<SupervisorFormsProps> = (
  props: SupervisorFormsProps,
) => {
  const supervisors = props.data;
  const chiefSupervisor = supervisors?.[0];
  const hasSupervisorTeam = supervisors.length > 1;
  const supervisorTeam = hasSupervisorTeam ? supervisors?.slice(1) : [];

  const supervisorsTeamMembersMigrated = supervisorTeam?.map(member => {
    const { type, ...other } = member;
    return {
      type: supTeamRoleTypeMigrateMappings[type] ?? type,
      ...other,
    };
  });
  const otherSupervisors = supervisorsTeamMembersMigrated;

  return (
    <Container>
      <>
        <h1>{NOMINATION_TEXT.CHIEF_SUPERVISOR.CHIEF_SUPERVISOR.TITLE}</h1>
        <SupervisorForm data={chiefSupervisor} />
      </>

      <h1>{NOMINATION_TEXT.SUPERVISOR_TEAM.TITLE}</h1>
      {hasSupervisorTeam ? (
        <>
          {otherSupervisors.map((supervisor, index) => (
            <div className="supervisor-team" key={index}>
              <h3>
                {index + 1}
                {' - '}
                {ROLE_TYPE[supervisor.type as keyof typeof ROLE_TYPE]}
              </h3>
              <SupervisorForm data={supervisor} />
            </div>
          ))}
        </>
      ) : (
        <div className="ml-4 mb-2">
          <h3>{'-'}</h3>
        </div>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  h1 {
    text-align: left !important;
    font-size: 1rem !important;
    font-weight: 500 !important;
    margin: 1rem !important;
  }

  h3 {
    font-size: 1rem !important;
    margin-left: 1rem !important;
    font-weight: 500 !important;
  }

  .supervisor-team {
    margin-bottom: 1rem;
  }
`;
